<template>
  <div
    class="requote elevation-1 d-flex align-center"
  >
    <div class="requote-content row justify-center align-center">
      <span class="mr-5">Return to </span>
      <a
        class="d-flex align-center"
        :href="redirectUrl"
      >
        <img
          :src="partnerImage"
          :alt="`${partnerText} Logo`"
          class="logo mr-5"
        >
        <span class="link-text">Here</span>
      </a>
    </div>
    <span
      class="link-text details"
      @click="$emit('on-click-how-it-works')"
    >
      How it works
    </span>
  </div>
</template>

<script>
export default {
  name: 'results-requote',
  props: {
    partnerImage: {
      type: String,
      default: '',
    },
    partnerText: {
      type: String,
      default: '',
    },
    redirectUrl: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
  .requote {
    position: fixed;
    bottom: 0;
    z-index: 4;
    width: 100%;
    padding: 10px 25px;
    background: rgba($color: $clr-black, $alpha: 0.7);

    @media screen and (max-width: 768px) {
      flex-direction: column-reverse;
    }
  }

  .requote-content {
    flex-grow: 1;
    color: $clr-white;

    @media screen and (max-width: 768px) {
      margin-bottom: 5px;
    }
  }

  .logo {
    height: 25px;
  }

  .link-text {
    color: $clr-white;
    text-decoration: underline;
    cursor: pointer;
  }

  .details {
    @media screen and (max-width: 768px) {
      margin-bottom: 25px;
    }
  }
</style>
